import { render } from "./sendOtp.vue?vue&type=template&id=04e70a6a&scoped=true"
import script from "./sendOtp.vue?vue&type=script&lang=js"
export * from "./sendOtp.vue?vue&type=script&lang=js"

import "./sendOtp.vue?vue&type=style&index=0&id=04e70a6a&scoped=true&lang=scss"

import exportComponent from "D:\\Build Apps\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e70a6a"]])

export default __exports__